if (!customElements.get('lookbook-banner')) {
  class LookbookBanner extends HTMLElement {
    constructor() {
      super()
      this.contentWrapper = this.querySelector('.js-content')

      if (this.contentWrapper) {
        this.adjustHeight()
        window.addEventListener('resize', () => {
          this.adjustHeight()
        })
      }
    }

    adjustHeight = () => {
      this.style.setProperty('--inner-height', `calc(var(--height) - ${this.contentWrapper.scrollHeight}px)`);
    }
  }

  customElements.define('lookbook-banner', LookbookBanner)
}
